import { render, staticRenderFns } from "./RoyGroup.vue?vue&type=template&id=2d1618bc&scoped=true&"
import script from "./RoyGroup.vue?vue&type=script&lang=js&"
export * from "./RoyGroup.vue?vue&type=script&lang=js&"
import style0 from "./RoyGroup.vue?vue&type=style&index=0&id=2d1618bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1618bc",
  null
  
)

export default component.exports